import {
  gsap,
  ScrollToPlugin,
  ScrollTrigger,
  TweenLite,
} from 'gsap/all';

import antmovesLog from './antmovesConsole';
import HpSlider from './hp-slider';
import ProductSlider from './product-slider';
import TrainersTabs from './ifit-trainers-tabs';
import TrainersModals from './ifit-trainers-modals';
import ifitTrainersSlider from './ifit-training-slider';
const GLightbox = require('glightbox');
import Cookies from 'js-cookie';

import MainNavigation from './nav';

class App {
  constructor() {
    const app = this;
    antmovesLog();

    const lightbox = GLightbox();

    gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
    window.gsap = gsap;
    this.nav = new MainNavigation();

    if (document.querySelector('.hp-slider')) {
      new HpSlider();
    }

    if (document.querySelector('.product-header__images')) {
      new ProductSlider();
    }

    if (document.querySelector('.ifit-trainers-tabs')) {
      new TrainersTabs();
    }

    if (document.querySelector('.trainer-modals')) {
      new TrainersModals();
    }

    if (document.querySelector('.ifit-training-slider')) {
      new ifitTrainersSlider();
    }

    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault();

        if (this.getAttribute('href') !== '#' && document.querySelector(this.getAttribute('href'))) {
          document.querySelector(this.getAttribute('href')).scrollIntoView({
            behavior: 'smooth'
          });
        }
      });
    });




    if (document.querySelector('.header__search')) {
      document.querySelector('.header__search').addEventListener('click', function (e) {
        e.preventDefault();
        document.body.classList.add('hide-overflow');
        var tl = gsap.timeline();
        tl.to(document.querySelector('.search__container'), {
          height: "100%",
          duration: .4,
          pointerEvents: "all"
        }).to(document.querySelector('.search__form'), {
          opacity: 1,
          duration: .3
        }).call(() => {
          document.querySelector('.dgwt-wcas-search-input').focus();
        });
      });
      document.querySelector('.search__form-close').addEventListener('click', function (e) {
        e.preventDefault();
        var tl = gsap.timeline();
        tl.to(document.querySelector('.search__form'), {
          opacity: 0,
          duration: .3,
        }).to(document.querySelector('.search__container'), {
          height: 0,
          duration: .4,
          pointerEvents: "none"
        }).call(() => {
          document.body.classList.remove('hide-overflow');
        });
      });

    }
  }

}
export default App;
